import React, { FC } from 'react';
import TouchableElement from '@components/common/touchableElement';
import { ColorFunction } from '@styles/colors/types';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { ICON_BUTTON_PADDING } from '@v2/pages/common/constants/base.constants';
import Svg from '@styles/icons/svg';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SimpleOnPress } from '@interfaces/base';

interface MoreButtonProps extends SimpleOnPress {
  C: ColorFunction;
  scale?: ScaleFunction;
  testID?: string;
}

const MoreButton: FC<MoreButtonProps> = ({ C, onPress, scale = initialScale, testID }) => {
  return (
    <TouchableElement testID={testID} onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
              padding: scale(ICON_BUTTON_PADDING),
              borderRadius: scale(18),
            },
          ]}
        >
          <Svg icon="more" width={scale(22)} height={scale(22)} color={'Button/Light/Primary'} style={{ overflow: 'visible' }} />
        </View>
      )}
    </TouchableElement>
  );
};

export default MoreButton;
